module.exports = __webpack_public_path__ + "img/img15.49c4e1b7.png";